/* eslint-disable react/require-default-props */
import './FormLayout.scss';

type FormLayoutProps = {
  className?: string;
  headerComponent?: React.ReactNode;
  footerComponent?: React.ReactNode;
  children: React.ReactNode;
};

const FormLayout = ({
  headerComponent,
  footerComponent,
  children,
  className,
}: FormLayoutProps): JSX.Element => {
  return (
    <div className={className}>
      <div className="form-layout">
        {headerComponent && headerComponent}
        <div className="form-content-container-background">
          <div className="form-content-container">
            <div className="form-content">{children}</div>
          </div>
        </div>
        {footerComponent && footerComponent}
      </div>
    </div>
  );
};

export default FormLayout;
